export default __webpack_public_path__ + "images/triangle-icon.310d3bacab03306243982ef4776b698d.svg";